export default __webpack_public_path__ + "static/media/sublevel4_2.78bc3d9f.webp";